import Teacher from '@/api/home/teacher'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  profile: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_PROFILES(state, data) {
    state.profile = data
  }
}

export const actions = {
  fetchProfile(context = {}) {
    return Teacher.getProfile().then(response => {
      context.commit('RECEIVE_PROFILES', response.data)
      return Promise.resolve(response)
    })
  },

  uploadPhoto(context, data) {
    return Teacher.uploadPhoto(data)
  },
  changePwd(context, data) {
    return Teacher.changePassword(data)
  },
  fetchCurrentClasses(context) {
    return Teacher.getClassOperation({
      params: {
        page: -1,
        include: 'branch,academic_year,grade',
        fields: {
          academic_classes:
            'class_id,class_name,branch_id,ac_year_id,grade_id,ac_status_id',
          branch: 'branch_id,branch_name_en',
          academic_year: 'ac_year_id,ac_year',
          grade: 'grade_id,grade_name_foreign'
        },
        filter: {
          ac_status_id: 1,
          teacher_response: true
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchHistoryClasses(context) {
    return Teacher.getClassOperation({
      params: {
        page: -1,
        include: 'branch,academic_year,grade',
        fields: {
          academic_classes:
            'class_id,class_name,branch_id,ac_year_id,grade_id,ac_status_id',
          branch: 'branch_id,branch_name_en',
          academic_year: 'ac_year_id,ac_year',
          grade: 'grade_id,grade_name_foreign'
        },
        filter: {
          ac_status_id: 2,
          teacher_response: true
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  schedule(context) {
    return Teacher.schedule()
  }
}
